export default "__VITE_ASSET__Hdn1sayC__"